module.exports = __webpack_public_path__ + "img/bonus_symbol_3.e36752e9.png";